import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { FormControl, FormLabel } from '@material-ui/core'
import { TreeSelect } from 'antd'
import 'antd/dist/antd.css'
import { MISC } from '@const'

/**
 * @props
 * {hideAllGame: boolean} '全部遊戲'選項開關
 * {defaultAll: boolean}  預設選取所有遊戲
 * {slotOnly: boolean} 只顯示電子遊戲
 * {disabledList: string[]} 不可變更選取的遊戲清單
 */
const initState = {
    hideTitle: false,
    gameList: [],
    slotOnly: false,
    treeData: [],
    gameOpenedList: [],
    typeName: ''
}

class GameMultiSelect extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'GameMultiSelect', options)
        }
        this.state = initState
    }

    componentDidMount() {
        this.setState({
            ...initState,
            gameList: this.props.gameList || []
        })
        this.props.onRef(this)
        this.handleInit()
    }


    componentDidUpdate() {
        if (this.props?.typeName && this.props.typeName !== this.state.typeName) {
            this.handleInit()
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    handleInit() {
        switch(this.props.typeName) {
            case MISC.EVENT_GIVE_FREE_GAME:
                this.setState({
                    slotOnly: true,
                    gameOpenedList: this.props.gameOpenedList,
                    typeName: this.props.typeName
                }, () => {
                    this.handleGameTreeData()
                })
                break
            case MISC.EVENT_DRAGON_TIGER_BOARD:
                this.setState({
                    slotOnly: true,
                    gameOpenedList: [],
                    typeName: this.props.typeName
                }, () => {
                    this.handleGameTreeData()
                })
                break
            case MISC.EVENT_RED_PACKET:
                this.setState({
                    slotOnly: false,
                    gameOpenedList: this.props.gameOpenedList,
                    typeName: this.props.typeName
                }, () => {
                    this.handleGameTreeData()
                })
                break
            default:
                this.setState({
                    slotOnly: false,
                    gameOpenedList: [],
                    typeName: ''
                }, () => {
                    this.handleGameTreeData()
                })
        }
    }

    handleGameTreeData() {
        let treeData = utils.generateGameTreeData(this.state.slotOnly, this.state.gameOpenedList)
        const gameList = []
        const disabledList = this.props?.disabledList || []
        const defaultAll = this.props?.options?.defaultAll || false
        /** 預設選取全部遊戲 */
        if (defaultAll) {
            treeData.forEach(gameType => {
                gameType.children.forEach(game =>{
                    gameList.push(game.value) 
                })
            })
            this.setState({
                gameList
            })
        }
        /** 設定不得選取遊戲 */
        if (disabledList.length) {
            treeData.forEach((gameType, index) => {
                gameType.children.forEach((game, gameIndex) =>{
                    if (disabledList.includes(game.value)) {
                        treeData[index].children[gameIndex]['disabled'] = true
                    }
                })
            })
        }

        /** 新增全部遊戲選項 */
        if (this.props?.options?.hideAllGame === false) {
            treeData = [{
                key: 'all',
                value: 'all',
                title: this.t('allGame'),
                children: treeData
            }]
        }

        this.setState({
            treeData,
        })
    }


    render() {
        const lobby = [{
            title: utils.t('gameLobby'),
            key: 'gameLobby',
            value: 'gameLobby'
        }]
        return (
            <React.Fragment>
                <FormControl className={this.props.classes.formControl}>
                    {!this.props.hideTitle && <FormLabel className={this.props.classes.shrink}>{this.t('selectGame')}</FormLabel>}
                    {this.props.subTitle && <FormLabel className={this.props.classes.shrink}>{this.props.subTitle}</FormLabel>}
                    <TreeSelect
                        className={this.props.classes.treeSelect}
                        treeData={
                            this.props?.gameLobby === true ? 
                            [...lobby, ...this.state.treeData] :
                            this.state.treeData
                        }
                        value={this.state.gameList}
                        onChange={(value) => {
                            this.setState({
                                gameList: value,
                            })
                            if (this.props.checkValue) {
                                this.props.checkValue(value)
                            }
                        }}
                        maxTagCount={1}
                        treeCheckable={true}
                        showSearch={true}
                        listHeight={64}
                        showCheckedStrategy={TreeSelect.SHOW_CHILD}
                        searchPlaceholder={this.t('pleaseSelect')}
                        dropdownStyle={{ zIndex: 3000 }}
                        getPopupContainer={()=>{
                            return document.getElementById('treeSelectBox')
                        }}
                    />
                </FormControl>
            </React.Fragment>
        )
    }
}

GameMultiSelect.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    onRef: PropTypes.func.isRequired,
    auth: PropTypes.object,
    dataService: PropTypes.object,
    options: PropTypes.object,
	subTitle: PropTypes.string,
	hideTitle: PropTypes.bool,
    slotOnly: PropTypes.bool,
    disabledList: PropTypes.array,
    gameList: PropTypes.array,
    typeName: PropTypes.string,
    gameOpenedList: PropTypes.array,
    gameLobby: PropTypes.bool,
    checkValue: PropTypes.func,
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '100%',
        },
        treeSelect: {
            width: 240,
        },
        shrink: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left',
        },
        hide: {
            display: 'none',
        },
    }
}

export default hoc(styles)(GameMultiSelect)
